var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showNameModal
    ? _c("div", { staticClass: "name-modal" }, [
        _c("div", { staticClass: "name-card" }, [
          _c("h3", [_vm._v("首次进入，请为角色起名")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nameInput,
                expression: "nameInput",
              },
            ],
            ref: "nameInputField",
            attrs: { placeholder: "输入名字..." },
            domProps: { value: _vm.nameInput },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.submitName.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.nameInput = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "name-buttons" }, [
            _c("button", { on: { click: _vm.submitName } }, [_vm._v("确认")]),
            _vm._v(" "),
            _c("button", { on: { click: _vm.randomName } }, [_vm._v("随机")]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }